// THUMBS
document.querySelectorAll('.Index_object_compare_list_item_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {

    const totalSlides = el.querySelectorAll('.swiper-slide').length;

    swiperThumbs = new Swiper(el, {
      loop: false,
      loopedSlides: totalSlides,
      spaceBetween: 14,
      slidesPerView: 7,
      slideToClickedSlide: true,
      watchSlidesProgress: true,
      direction: 'vertical',
      breakpoints: {
        0: {
            spaceBetween: 8,
            slidesPerView: "auto",
            direction: 'horizontal'
        },
        750: {
            spaceBetween: 10,
            slidesPerView: 7,
            direction: 'vertical'
        },
        990: {
            spaceBetween: 14,
            slidesPerView: 7
        },
        1200: {
        },
        1440: {
        }
      }
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {

  function initHoverTabsOnlyForSlider() {
    document.querySelectorAll(".Index_object_compare_list_item_slider").forEach(slider => {
      
      const container = slider.closest(".Tabs_common_main_new");
      if (!container) return;

      const tabs = slider.querySelectorAll(".Tabs_common_inner_new");

      let hoverTimeout;

      tabs.forEach(tab => {
        tab.addEventListener("mouseenter", () => {
          if (window.innerWidth < 750) return;

          clearTimeout(hoverTimeout);

          hoverTimeout = setTimeout(() => {
            // trigger existing click logic instead of rewriting it
            tab.click();
          }, 120); // adjust delay if needed
        });
      });

    });
  }

  initHoverTabsOnlyForSlider();

  // Shopify section reload support
  document.addEventListener("shopify:section:load", function () {
    initHoverTabsOnlyForSlider();
  });

});